<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <NuxtLayout name="center">
        <h1>{{ contendData.title }}</h1>
        <div class="flex md:my-16 my-8 md:mx-8 text-dark-blue md:space-x-12 lg:space-x-24 rtl:space-x-reverse">
          <div class="hidden md:block w-full max-w-[240px] lg:max-w-[300px] md:sticky self-start top-40">
            <BaseTableOfContent :content-ref="conditionContent" :auto-focus-first="true" />
          </div>
          <div class="w-full">
            <article>
              <div ref="conditionContent" class="condition-content -mt-15">
                <div v-if="isArrayOfObjects" v-for="(content, key) in contendData.body_text" class="mb-1">
                  <div v-if="content.type == 'text'" v-html="content.text"></div>
                  <div v-else-if="content.type == 'cta'">
                    <CommonCTA
                      :title="content.title"
                      :url="content.url"
                      :open_in_new_tab="content.open_in_new_tab"
                    ></CommonCTA>
                  </div>
                  <div
                    v-else-if="content.type == 'cookiebot' && content.enable_declaration == true"
                    id="cookiebotDeclaration"
                  ></div>
                </div>
                <div v-else v-html="contendData.body_text" class="mb-1"></div>
              </div>
            </article>
          </div>
        </div>
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";
const globalStore = useGlobalStore();

const route = useRoute();
const props = defineProps({
  data: {
    type: Function,
  },
});
const contendData = ref();
const conditionContent = ref(null);
const { data: results, error, refresh } = await useServiceTypePageDetail(route.params.slug);

const assertServicePage = () => {
  if (!error.value) return;

  throw createError({
    fatal: true,
    statusCode: error.value.statusCode ?? 404,
    statusMessage: error.value.statusMessage,
  });
};

assertServicePage();
contendData.value = results.value.data;

watch(
  () => route.params.slug,
  async () => {
    await refresh();
    assertServicePage();
    contendData.value = results.value?.data;
  }
);

const isArrayOfObjects = Array.isArray(contendData.value.body_text);

onMounted(() => {
  addCookiebotDeclarationScript(globalStore.siteSettings.cookiebot_notice, globalStore.siteSettings.cookiebot_id);
});

useMetaTitles(contendData.value, "service-type-page");

const breadcrumbs = getBreadcrumbs("service-type-page", contendData.value);
</script>

<style scoped>
.condition-content :deep(a) {
  @apply text-secondary underline hover:no-underline;
}
</style>
